import { gql } from "@apollo/client"

export const SIGN_UP_FOR_MOTION = gql`
  mutation signUpForMotion($email: String!, $company: String, $firstName: String, $lastName: String, $phone: String) {
    signUpForMotion(email: $email, company: $company, firstName: $firstName, lastName: $lastName, phone: $phone) {
      success
    }
  }
`
